module.exports = __webpack_public_path__ + "static/media/Ic_Sandglass.d35c0c61.svg";